import { render, staticRenderFns } from "./LiveHomeWidget.vue?vue&type=template&id=83e4092a"
import script from "./LiveHomeWidget.vue?vue&type=script&lang=js"
export * from "./LiveHomeWidget.vue?vue&type=script&lang=js"
import style0 from "./LiveHomeWidget.vue?vue&type=style&index=0&id=83e4092a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports